import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import localizationJson from './assets/jsons/localization.json';

i18n
  .use(initReactI18next)
  .init({
    lng: 'uk',
    debug: true,
    resources: localizationJson
  });

export default i18n;